export default function MySQL_LEAST() {
  return (
    <div>
      <h2>MySQL_LEAST</h2>    </div>
  );
}